import React, { FC } from 'react';
import styles from './light_header.module.scss';
import { HeaderContent } from '../HeaderContent';
import { withUser } from '../../user/UserContext';
import { UserContextType } from '../../user/user.types';
import { HeaderContentLogo } from '../HeaderContentLogo';

type Props = { source: string } & UserContextType;

export const RawLightHeader: FC<Props> = ({ loggedIn, source, children }) => (
  <header id="nav" className={styles.container}>
    <HeaderContent>
      <div className={styles.wrapper}>
        <HeaderContentLogo loggedIn={loggedIn} source={source} />
        <div>{children}</div>
      </div>
    </HeaderContent>
  </header>
);

export const LightHeader = withUser(RawLightHeader);
